import React from "react"
import { useSelector } from "react-redux"
import { Container } from "react-bootstrap"
import { roleCheck } from "utils/index"
import { ADMIN } from "utils/constants"
import { getCurrentRole, getCurrentUser } from "apps/App/reducers"
import ProductForm from "./ProductForm"

export default function NewProduct() {
  const currentUser = useSelector(getCurrentUser)
  const currentRole = useSelector(getCurrentRole)
  const systemRole = currentUser.attributes.role

  if (!roleCheck(systemRole, currentRole, ADMIN)) window.location = "/"

  return (
    <Container fluid className="pb-5">
      <ProductForm />
    </Container>
  )
}
